/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoodsDetail
 */
export interface GoodsDetail {
    /**
     * 实际重量
     * @type {number}
     * @memberof GoodsDetail
     */
    realWeight?: number;
    /**
     * 体积重量
     * @type {number}
     * @memberof GoodsDetail
     */
    volumnWeight?: number;
    /**
     * 体积合计
     * @type {number}
     * @memberof GoodsDetail
     */
    volumnSum?: number;
    /**
     * 体积（CBM）
     * @type {number}
     * @memberof GoodsDetail
     */
    cbm?: number;
    /**
     * 箱子长
     * @type {number}
     * @memberof GoodsDetail
     */
    length?: number;
    /**
     * 箱子宽
     * @type {number}
     * @memberof GoodsDetail
     */
    width?: number;
    /**
     * 箱子高
     * @type {number}
     * @memberof GoodsDetail
     */
    height?: number;
    /**
     * 体积适用率
     * @type {number}
     * @memberof GoodsDetail
     */
    volumnApplyRate?: number;
    /**
     * 追加快递费用
     * @type {number}
     * @memberof GoodsDetail
     */
    addDeliveryFee?: number;
    /**
     * 适用重量
     * @type {number}
     * @memberof GoodsDetail
     */
    applyWeight?: number;
}

/**
 * Check if a given object implements the GoodsDetail interface.
 */
export function instanceOfGoodsDetail(value: object): value is GoodsDetail {
    return true;
}

export function GoodsDetailFromJSON(json: any): GoodsDetail {
    return GoodsDetailFromJSONTyped(json, false);
}

export function GoodsDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoodsDetail {
    if (json == null) {
        return json;
    }
    return {
        
        'realWeight': json['realWeight'] == null ? undefined : json['realWeight'],
        'volumnWeight': json['volumnWeight'] == null ? undefined : json['volumnWeight'],
        'volumnSum': json['volumnSum'] == null ? undefined : json['volumnSum'],
        'cbm': json['cbm'] == null ? undefined : json['cbm'],
        'length': json['length'] == null ? undefined : json['length'],
        'width': json['width'] == null ? undefined : json['width'],
        'height': json['height'] == null ? undefined : json['height'],
        'volumnApplyRate': json['volumnApplyRate'] == null ? undefined : json['volumnApplyRate'],
        'addDeliveryFee': json['addDeliveryFee'] == null ? undefined : json['addDeliveryFee'],
        'applyWeight': json['applyWeight'] == null ? undefined : json['applyWeight'],
    };
}

export function GoodsDetailToJSON(json: any): GoodsDetail {
    return GoodsDetailToJSONTyped(json, false);
}

export function GoodsDetailToJSONTyped(value?: GoodsDetail | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'realWeight': value['realWeight'],
        'volumnWeight': value['volumnWeight'],
        'volumnSum': value['volumnSum'],
        'cbm': value['cbm'],
        'length': value['length'],
        'width': value['width'],
        'height': value['height'],
        'volumnApplyRate': value['volumnApplyRate'],
        'addDeliveryFee': value['addDeliveryFee'],
        'applyWeight': value['applyWeight'],
    };
}

